<template>
  <main class="apple-tesla-home">

    <!-- Hero Section cu Fundal Fixat (Fără bandă albă jos) -->
    <section class="hero-section hero-bg-image text-center">
      <div class="hero-overlay">
        <b-container>
          <b-row align-h="center" class="justify-content-center">
            <b-col lg="8" md="10">
              <span class="badge-subtle-hero">Livrare rapidă &amp; simplă</span>
              <h1 class="hero-title-hero">Comandă simplu și rapid</h1>
              <p class="hero-subtitle-hero">
                Cele mai bune restaurante cu cele mai bune prețuri, livrate direct la ușa ta sau la birou.
              </p>

              <!-- Search Bar Modern -->
              <div class="search-wrapper">
                <form @submit="search" class="search-input-container">
                  <svg class="search-icon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <circle cx="11" cy="11" r="8"></circle>
                    <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                  </svg>

                  <b-input
                      type="text"
                      v-model="searchTerm"
                      class="custom-search-input"
                      @keyup.enter="search"
                      placeholder="Orașul sau numele restaurantului..."
                  ></b-input>

                  <button class="btn-search-action" type="submit">
                    Caută
                  </button>
                </form>
              </div>

            </b-col>
          </b-row>
        </b-container>
      </div>
    </section>

    <!-- Sectiune Orașe -->
    <section class="cities-section py-5">
      <b-container>
        <div class="section-header text-center mb-5">
          <h2 class="section-title">Alege un oraș pentru a vizualiza restaurantele</h2>
          <p class="section-subtitle">Selectează o localitate pentru a explora ofertele disponibile</p>
        </div>

        <b-row class="cities-wrapper justify-content-center">
          <b-col md="4" sm="12" v-for="(city, index) in cities" :key="index" class="mb-4">
            <router-link
                class="city-card"
                :to="{ name: 'public.city.details', params: { slug: city.slug } }"
            >
              <div class="card-image-wrapper">
                <b-img :src="'/cities/' + city.slug + '.jpg'" fluid class="city-image" :alt="city.name"></b-img>
                <div class="card-overlay"></div>
                <div class="card-info">
                  <h3 class="city-title">{{ city.name }}</h3>
                  <span class="explore-btn">
                    Explorează
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>
                  </span>
                </div>
              </div>
            </router-link>
          </b-col>
        </b-row>

        <!-- Loader infinit -->
        <div v-if="isBusy" class="text-center py-4">
          <span class="loading-spinner"></span>
        </div>
      </b-container>
    </section>

    <!-- Banner Corporate / B2B Promo -->
    <section class="banner-section py-5" v-if="restaurants.length > 0">
      <b-container>
        <div class="glass-banner-card">
          <div class="banner-content text-center text-md-left">
            <span class="banner-badge">Coressy delivery</span>
            <h3 class="banner-title">Livrăm și la tine la birou</h3>
            <p class="banner-text">Savurează preparatele delicioase la doar câteva minute de la comandă.</p>
            <a href="/restaurante" class="btn-banner-primary">Comandă acum</a>
          </div>
        </div>
      </b-container>
    </section>

    <!-- Secțiune Cum Funcționează -->
    <section class="how-it-works-section py-5">
      <b-container>
        <div class="section-header text-center mb-5">
          <span class="badge-subtle">Convinge-te singur</span>
          <h2 class="section-title">Cum funcționează</h2>
          <p class="section-subtitle">Trei pași simpli pentru a te bucura de mâncarea ta preferată</p>
        </div>

        <b-row class="justify-content-center gy-4">

          <b-col lg="4" md="6" class="mb-4">
            <div class="step-card">
              <div class="step-number">01</div>
              <div class="step-icon-wrapper">
                <img src="img/how_1.svg" alt="Comandă rapid" class="step-icon" width="80" />
              </div>
              <h3 class="step-title">Comandă rapid</h3>
              <p class="step-desc">Alege produsele dorite și comandă cu un singur click.</p>
            </div>
          </b-col>

          <b-col lg="4" md="6" class="mb-4">
            <div class="step-card">
              <div class="step-number">02</div>
              <div class="step-icon-wrapper">
                <img src="img/how_2.svg" alt="Livrare rapidă" class="step-icon" width="80" />
              </div>
              <h3 class="step-title">Livrare rapidă</h3>
              <p class="step-desc">Termenul de livrare este de maxim 60 de minute din momentul comenzii.</p>
            </div>
          </b-col>

          <b-col lg="4" md="6" class="mb-4">
            <div class="step-card">
              <div class="step-number">03</div>
              <div class="step-icon-wrapper">
                <img src="img/how_3.svg" alt="Poftă bună" class="step-icon" width="80" />
              </div>
              <h3 class="step-title">Poftă bună</h3>
              <p class="step-desc">Savurează produsele comandate acasă sau la birou.</p>
            </div>
          </b-col>

        </b-row>
      </b-container>
    </section>

  </main>
</template>

<script>
import PublicRestaurants from '@/components/publicEndpoints/restaurants'
import PublicCities from '@/components/publicEndpoints/cities'
import axios from "axios";

export default {
  name: 'Home',
  created () {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  data() {
    return {
      restaurants: [],
      slides: [
        {img: '/img/1.jpg'},
        {img: '/img/1.jpg'},
        {img: '/img/1.jpg'},
        {img: '/img/1.jpg'},
      ],
      cities: [],
      paging: {
        page: 1,
        per_page: 12,
        total: 10,
        lastPage: 1000
      },
      filters: {},
      searchTerm: '',
      lazyLoadingBusy: false,
      endOfResults: false,
      isBusy: false,
    }
  },
  methods: {
    search(e) {
      if (e) e.preventDefault();
      this.$router.push({ name: 'public.restaurants', params: { searchTerm: this.searchTerm } });
    },
    getRestaurants() {
      const params = { page: 1, per_page: 8 };
      PublicRestaurants.getAll(params).then(response => {
        this.restaurants = response.data.data;
      });
    },
    askLocation() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(this.getPosition);
      }
    },
    getPosition(position) {
      const lat = position.coords.latitude;
      const lon = position.coords.longitude;
      axios.get(process.env.VUE_APP_API_URL + '/public/get_location/' + lat + '/' + lon).then(response => {
        this.searchTerm = '';
        if (response.data.route) {
          this.searchTerm += response.data.route;
        }
        if (response.data.street_number) {
          this.searchTerm += ' ' + response.data.street_number;
        }
        if (response.data.locality) {
          this.searchTerm += ', ' + response.data.locality;
        }
      });
    },
    getCities(clearResults = false) {
      if (this.endOfResults || this.isBusy) {
        return;
      }
      this.isBusy = true;
      PublicCities.getAll(this.paging, this.filters).then((response) => {
        if (response.data.data.length === 0) {
          this.endOfResults = true;
        }
        if (clearResults) {
          this.cities = response.data.data;
        } else {
          response.data.data.forEach((city) => {
            if (!this.cityExists(city.id)) {
              this.cities.push(city);
            }
          });
        }
        this.paging.total = response.data.meta.total;
        this.paging.lastPage = response.data.meta.last_page;
        this.isBusy = false;
        this.lazyLoadingBusy = false;
      }).catch(() => {
        this.isBusy = false;
        this.lazyLoadingBusy = false;
      });
    },
    handleScroll: function (e) {
      if (this.lazyLoadingBusy || this.endOfResults) {
        return;
      }
      const target = e.target.body || document.documentElement;
      const bodyHeight = target.offsetHeight;
      const innerHeight = window.innerHeight;
      const scrollY = window.scrollY;
      const citiesWrapper = document.querySelector('.cities-wrapper');
      const beforeBottom = citiesWrapper ? citiesWrapper.offsetTop : 800;
      const overSize = 200;

      if (innerHeight + scrollY + overSize >= bodyHeight - beforeBottom) {
        this.lazyLoadingBusy = true;
        this.paging.page++;
        this.getCities();
      }
    },
    cityExists(id) {
      return this.cities.some((el) => {
        return el.id === id;
      });
    },
  },
  mounted() {
    this.getCities(true);
  },
  metaInfo() {
    return {
      title: 'CORESSY delivery - Livrăm pentru tine',
      meta: [
        { name: 'description', content: 'Comandă preparate gustoase iar CORESSY delivery ți le va livra în cel mai scurt timp'},
        { property: 'og:title', content: 'Coressy Delivery livrează pentru tine'},
        { property: 'og:site_name', content: 'Coressy Delivery'},
        { property: 'og:description', content: 'Comandă preparate gustoase iar CORESSY delivery ți le va livra în cel mai scurt timp'},
        { property: 'og:image', content: 'https://coressy.com' + process.env.VUE_APP_LOGO_PATH }
      ]
    }
  }
}
</script>

<style scoped>
/* Main Container */
.apple-tesla-home {
  padding-bottom: 80px;
  background-color: #f5f5f7;
  color: #1d1d1f;
  min-height: 100vh;
  font-family: -apple-system, BlinkMacSystemFont, "SF Pro Display", "SF Pro Text", "Helvetica Neue", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
}

/* Hero Section - Culoare de fundal solidă setată ca fallback să elimine banda albă de jos */
.hero-bg-image {
  position: relative;
  background-color: #121215;
  background-image: url('/img/banner_bg.png');
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  display: flex;
  align-items: center;
}

.hero-overlay {
  width: 100%;
  padding: 130px 0 90px 0;
  background: linear-gradient(180deg, rgb(18 18 21 / 0%) 0%, rgba(18, 18, 21, 0.94) 100%);
}

.badge-subtle-hero {
  display: inline-block;
  text-transform: uppercase;
  font-size: 0.75rem;
  letter-spacing: 2px;
  font-weight: 600;
  color: #0071e3;
  background: rgba(255, 255, 255, 0.95);
  padding: 4px 14px;
  border-radius: 980px;
  margin-bottom: 16px;
}

.hero-title-hero {
  font-size: 3.5rem;
  font-weight: 700;
  letter-spacing: -0.02em;
  color: #ffffff;
  margin-bottom: 16px;
  line-height: 1.08;
}

@media (max-width: 768px) {
  .hero-title-hero {
    font-size: 2.4rem;
  }
}

.hero-subtitle-hero {
  font-size: 1.15rem;
  line-height: 1.48;
  color: #e5e5ea;
  max-width: 600px;
  margin: 0 auto 36px auto;
  font-weight: 400;
}

/* Search Bar Apple Modern */
.search-wrapper {
  max-width: 560px;
  margin: 0 auto;
}

.search-input-container {
  position: relative;
  display: flex;
  align-items: center;
  background: #ffffff;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 980px;
  padding: 6px 6px 6px 18px;
  box-shadow: 0 16px 36px rgba(0, 0, 0, 0.35);
  transition: all 0.25s ease;
}

.search-input-container:focus-within {
  border-color: #0071e3;
  box-shadow: 0 16px 40px rgba(0, 113, 227, 0.4);
}

.search-icon {
  color: #86868b;
  margin-right: 10px;
  flex-shrink: 0;
  display: block;
}

.custom-search-input {
  border: none !important;
  background: transparent !important;
  box-shadow: none !important;
  padding: 0 !important;
  margin: 0 !important;
  font-size: 0.95rem !important;
  color: #1d1d1f !important;
  height: 24px !important;
  line-height: 24px !important;
  display: flex !important;
  align-items: center !important;
}

.custom-search-input::placeholder {
  color: #86868b;
  line-height: normal;
}

.btn-search-action {
  background-color: #0071e3;
  color: #ffffff;
  border: none;
  border-radius: 980px;
  padding: 10px 24px;
  font-size: 0.88rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
}

.btn-search-action:hover {
  background-color: #0077ed;
}

.btn-search-action:active {
  transform: scale(0.97);
}

/* Section Headers */
.badge-subtle {
  display: inline-block;
  text-transform: uppercase;
  font-size: 0.75rem;
  letter-spacing: 1.5px;
  font-weight: 600;
  color: #86868b;
  margin-bottom: 8px;
}

.section-title {
  font-size: 2rem;
  font-weight: 700;
  letter-spacing: -0.015em;
  color: #1d1d1f;
  margin-bottom: 8px;
}

.section-subtitle {
  font-size: 1rem;
  color: #86868b;
  margin-bottom: 0;
}

/* City Cards Style */
.city-card {
  display: block;
  text-decoration: none !important;
  border-radius: 20px;
  overflow: hidden;
  position: relative;
  background: #ffffff;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
  transition: transform 0.35s cubic-bezier(0.16, 1, 0.3, 1), box-shadow 0.35s ease;
}

.city-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 18px 40px rgba(0, 0, 0, 0.12);
}

.card-image-wrapper {
  position: relative;
  aspect-ratio: 4 / 3;
  overflow: hidden;
  background-color: #e5e5ea;
}

.city-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.5s cubic-bezier(0.16, 1, 0.3, 1);
}

.city-card:hover .city-image {
  transform: scale(1.05);
}

.card-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(180deg, rgba(0,0,0,0) 40%, rgba(0,0,0,0.65) 100%);
}

.card-info {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 24px;
  color: #ffffff;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}

.city-title {
  font-size: 1.5rem;
  font-weight: 700;
  margin: 0;
  letter-spacing: -0.01em;
  color: #ffffff;
}

.explore-btn {
  font-size: 0.82rem;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.85);
  display: flex;
  align-items: center;
  gap: 4px;
  transition: color 0.2s ease, transform 0.2s ease;
}

.city-card:hover .explore-btn {
  color: #ffffff;
  transform: translateX(3px);
}

/* Glass Banner Card */
.glass-banner-card {
  background: linear-gradient(135deg, #0071e3 0%, #004085 100%);
  border-radius: 24px;
  padding: 48px;
  color: #ffffff;
  box-shadow: 0 16px 36px rgba(0, 113, 227, 0.2);
}

.banner-badge {
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  color: rgba(255, 255, 255, 0.75);
  display: block;
  margin-bottom: 8px;
}

.banner-title {
  font-size: 2rem;
  font-weight: 700;
  margin-bottom: 12px;
  letter-spacing: -0.01em;
  color: #ffffff;
}

.banner-text {
  font-size: 1.05rem;
  color: rgba(255, 255, 255, 0.9);
  max-width: 500px;
  margin-bottom: 24px;
}

.btn-banner-primary {
  display: inline-block;
  background-color: #ffffff;
  color: #0071e3 !important;
  font-weight: 600;
  font-size: 0.95rem;
  padding: 12px 28px;
  border-radius: 980px;
  text-decoration: none !important;
  transition: all 0.2s ease;
}

.btn-banner-primary:hover {
  background-color: #f2f2f7;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
}

/* Step Cards */
.step-card {
  background: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 20px;
  padding: 36px 28px;
  text-align: center;
  position: relative;
  height: 100%;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.03);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.step-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 16px 36px rgba(0, 0, 0, 0.08);
}

.step-number {
  position: absolute;
  top: 18px;
  right: 22px;
  font-size: 0.85rem;
  font-weight: 700;
  color: #86868b;
  letter-spacing: 1px;
}

.step-icon-wrapper {
  margin-bottom: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 90px;
}

.step-icon {
  max-height: 80px;
  width: auto;
}

.step-title {
  font-size: 1.25rem;
  font-weight: 700;
  color: #1d1d1f;
  margin-bottom: 10px;
  letter-spacing: -0.01em;
}

.step-desc {
  font-size: 0.9rem;
  color: #6e6e73;
  line-height: 1.5;
  margin: 0;
}

/* Loader */
.loading-spinner {
  display: inline-block;
  width: 28px;
  height: 28px;
  border: 3px solid rgba(0, 0, 0, 0.1);
  border-radius: 50%;
  border-top-color: #0071e3;
  animation: spin 0.8s ease-in-out infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}
</style>
